import { instance } from '@/services/avik-api-gateway'
import { VehicleWithdrawalPenaltyAssessment } from '@/types/vehicle-withdrawal-penalty-assessment'
import { AxiosResponse } from 'axios'

export function createVehicleWithdrawalPenaltyAssessment(
  body: Partial<VehicleWithdrawalPenaltyAssessment>
): Promise<AxiosResponse<VehicleWithdrawalPenaltyAssessment>> {
  return instance.post(`/vehicle-withdrawal-penalty-assessment`, body)
}
